import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

const TURBO_STREAM = 'text/vnd.turbo-stream.html'

export default class extends Controller {
  static values = { url: String }

  connect () {
    fetch(this.urlValue, { headers: { Accept: TURBO_STREAM } })
      .then(async (response) => {
        if (!response.ok) return
        Turbo.renderStreamMessage(await response.text())
      })
      .finally(() => this.element.remove())
  }
}
